import { render, staticRenderFns } from "./SettingsLayout.vue?vue&type=template&id=c23210d6&scoped=true"
import script from "./SettingsLayout.vue?vue&type=script&lang=js"
export * from "./SettingsLayout.vue?vue&type=script&lang=js"
import style0 from "./SettingsLayout.vue?vue&type=style&index=0&id=c23210d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23210d6",
  null
  
)

export default component.exports